import PropTypes from 'prop-types';

const LoadingSpinner = ({ text = 'Fetching data...', theme = '' }) => (
  <div className={`loading-spinner d-flex ${theme}`}>
    <i className="fad fa-spinner-third animation-momentum-spin text-xx-large" />
    &nbsp;{text}
  </div>
);

LoadingSpinner.propTypes = {
  text: PropTypes.string,
  theme: PropTypes.string,
};

export default LoadingSpinner;
